<template>
    <div style="width: 100%; height: 100%">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div v-if="visible" ref="iframeContainer" style="width: 100%; height: 100%">
            <iframe @load="onLoad" style="width: inherit; height: inherit" :src="videoLink"> </iframe>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';

export default {
    props: {
        videoLink: String,
        videoId: Number,
        visible: Boolean,
        productCode: String,
    },

    data() {
        return {
            isLoading: true,
        };
    },

    mounted() {},

    computed: {
        ...mapStores(useUserStore, useBranchStore),
    },

    methods: {
        onLoad() {
            this.isLoading = false;

            const formData = new FormData();
            formData.append('user_id', this.userStore.user.id);
            formData.append('branch_id', this.branchStore.branch.id);
            formData.append('id', this.videoId);
            formData.append('product_code', this.productCode);
            navigator.sendBeacon(`/api/analytics/product-video/${this.videoId}/render`, formData);
        },
    },
};
</script>
